<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="sc of specialConsiderations"
      :value="sc"
      :key="sc.code">
        {{ sc.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { SpecialConsideration } from '@/store/master/types'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectSpecialConsiderationInput extends Vue {
  @Prop() value!: SpecialConsideration

  created() {
    this.$store.dispatch('fetchMasterSpecialConsiderations')
  }

  private get specialConsiderations(): SpecialConsideration[] {
    return (this.$store.state as RootState).master.specialConsiderations
  }

  private get selected(): SpecialConsideration {
    return this.value
  }

  private set selected(specialConsiderations: SpecialConsideration) {
    this.$emit('input', specialConsiderations || null)
  }
}
</script>

<style scoped>
  select {
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
